<template>
  <div>
    <v-row class="ma-10" justify="end">
      <v-dialog v-model="addNew" persistent max-width="1200px">
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            color="primary"
            dark
            v-bind="attrs"
            v-on="on"
            @click="goToForm()"
          >
            Novi event
          </v-btn>
        </template>
        <v-card>
          <v-card-title>
            <span class="headline">Kreiraj događaj </span>
          </v-card-title>

          <!-- Drop type of event -->
          <!-- item-text="naziv"
          item-value="naziv" -->
          <v-row>
            <v-col cols="12" class="mx-3">
              <v-select
                :items="event_type_list"
                label="Vrsta događaja"
                item-text="name"
                item-value="uid"
                v-model="return_event_object.event_type"
              ></v-select>
            </v-col>
          </v-row>

          <!-- <v-card-text> -->
          <v-row>
            <v-col cols="12" class="mx-3">
              <v-text-field
                label="Naslov događaja"
                v-model="return_event_object.title"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" class="mx-3">
              <v-textarea
                solo
                name="Opis"
                label="Opis događaja"
                v-model="return_event_object.body"
              ></v-textarea>
            </v-col>
          </v-row>

          <!-- is meeting all day-->
          <!--  start - datetime -->
          <v-row>
            <v-col cols="12" sm="4">
              <datetime
                format="YYYY-MM-DD H:i:s"
                v-model="return_event_object.begin_timestamp"
              ></datetime>
            </v-col>
            <v-col cols="12" sm="4">
              <datetime
                format="YYYY-MM-DD H:i:s"
                v-model="return_event_object.end_timestamp"
              ></datetime>
            </v-col>
            <v-col cols="12" sm="4">
              <v-label> Cijeli dan? </v-label>
              <v-checkbox
                v-model="return_event_object.all_day"
                hide-details
                class="shrink mr-2 mt-0"
              ></v-checkbox>
            </v-col>
          </v-row>
          <!--  end - datetime -->

         
          <!-- attendees - name - email+name , value: emai, name, id  START-->
          <v-row>
            <v-col cols="12" sm="6">
              <v-autocomplete
                v-model="return_event_object.selected_team"
                :items="team_members"
                filled
                chips
                color="blue-grey lighten-2"
                label="Odaberi članove tima"
                :item-text="getItemText"
                item-value="uid"
                multiple
              >
                <template v-slot:selection="data">
                  <div>
                    <v-chip
                      v-bind="data.attrs"
                      :input-value="data.selected"
                      close
                      @click="data.select"
                      @click:close="remove(data.item.uid)"
                    >
                      <v-avatar left>
                        <v-img :src="data.item.avatar"></v-img>
                      </v-avatar>
                      {{ data.item.ime }} {{ data.item.prezime }}
                    </v-chip>
                  </div>
                </template>
                <template v-slot:item="data">
                  <div></div>
                  <template v-if="typeof data.item === 'object'">
                    <v-list-item-content
                      v-text="data.item.ime + ' ' + data.item.prezime"
                    ></v-list-item-content>
                  </template>
                  <template v-else>
                    <v-list-item-avatar>
                      <img :src="data.item.avatar" />
                    </v-list-item-avatar>
                    <v-list-item-content>
                      <v-list-item-title
                        v-html="data.item.ime + ' ' + data.item.prezime"
                      ></v-list-item-title>
                      <v-list-item-subtitle
                        v-html="data.item.ime + ' ' + data.item.prezime"
                      ></v-list-item-subtitle>
                    </v-list-item-content>
                  </template>
                </template>
              </v-autocomplete>
            </v-col>
             <!--  SPIS SELECTOR BEGIN -->
            <v-col cols="12" sm="6">
              <v-select
                v-model="return_event_object.selected_spis"
                :items="spisList"
                item-text="ime"
                item-value="id_spis"
                label="Vezani spis"
              ></v-select>
            </v-col>
          <!-- SPIS SELECTOR END -->
          </v-row>

          <!-- Attendees END -->

          <!-- is_online meeting: true, false -->
          <v-row>
            <v-col cols="12" sm="3">
              <v-label> Online sastanak? </v-label>
              <v-checkbox
                v-model="return_event_object.is_online"
                hide-details
                class="shrink mr-2 mt-0"
              ></v-checkbox>
            </v-col>
            <!-- if is_online true -> onlineMeetingUrl -->
            <v-col cols="12" sm="6">
              <v-text-field
                v-model="return_event_object.online_url"
                :disabled="!return_event_object.is_online"
                label="URL linka za sastanak"
              ></v-text-field>
            </v-col>
          </v-row>

          <!-- if is_online false Location - name of the place -->

          <v-row>
            <v-col cols="12" sm="6">
              <v-text-field
                v-model="return_event_object.location_name"
                :disabled="is_online"
                label="Naziv lokacije sastanka"
              ></v-text-field>
            </v-col>
          </v-row>

          <!-- recurrence -->
          <!-- to još treba razraditi -->

          <!-- <v-row>
            <v-col cols="12" sm="3">
              <v-label> Ponavljajući događaj? </v-label>
              <v-checkbox
                v-model="is_online"
                hide-details
                class="shrink mr-2 mt-0"
              ></v-checkbox>
            </v-col> -->
          <!-- if is_online true -> onlineMeetingUrl -->
          <!-- <v-col cols="12" sm="3">
               <v-select
                :items="['low', 'normal', 'high']"
                label="Bitnoća događaja"
              ></v-select>
            </v-col>
          </v-row> -->

          <!-- type - daily, weekly, monthly -->

          <!-- importance -->
          <v-row>
            <v-col cols="12" class="mx-3">
              <v-select
                v-model="return_event_object.event_importance"
                :items="event_importance_list"
                item-text="name"
                item-value="value"
                label="Bitnoća događaja"
              ></v-select>
            </v-col>
          </v-row>

          <!-- reminderBefore in minutes -->
          <v-row>
            <v-col cols="12" class="mx-3">
              <v-label>
                Podsjeti me prije : {{return_event_object.remind_before_minutes}} min
              </v-label>
              <v-slider
                v-model="return_event_object.remind_before_minutes"
                step="1"
                min="0"
                max="60"
                thumb-label
                ticks
              ></v-slider>
            </v-col>
          </v-row>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="addNew = false">
              Odustani
            </v-btn>
            <v-btn color="blue darken-1" text @click="eventCheck()">
              Spremi
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </div>
</template>


<script>
import datetime from "vuejs-datetimepicker";
import ms_calendar from "@/apiCallers/calendarSharepoint";
import case_management from "@/apiCallers/promise_handler_db/predmeti";
export default {
  components: { datetime },
  props: {
    accessToken: {
      type: String,
      required: true,
      default: null,
    },
    caseId: {
      type: String,
      required: true,
      default: null,
    },
    spisList: {
      type: Array,
      required: true,
      default: [],
    },
  },

  data() {
    return {
      //List of data for select BEGIN
      addNew: false,
      event_type_list: [],
      team_members: [],
      event_importance_list: [
        { name: "Nisko", value: "low" },
        { name: "Srednje", value: "normal" },
        { name: "Visoko", value: "high" },
      ],
      //List of data for select END

      //object for v-model START
      return_event_object: {
        event_type: 1,
        title: "",
        body: "",
        begin_timestamp: null,
        end_timestamp: null,
        is_online: false,
        online_url: "",
        location_name: "",
        event_importance: "low",
        all_day: false,
        selected_spis : null,
        remind_before_minutes: 10,
        selected_team: [],
        case_id : "",
      },
      //object for v-model END
    };
  },
  async created() {
    //Get list of event types
    await ms_calendar.getEventType().then((resp) => {
      this.event_type_list = resp.data;
    });

    //get list of team members inside
    let groupUrl = this.$route.params.uid;

    await case_management.getCaseTeam(groupUrl).then((resp) => {
      console.log(groupUrl);
      console.log(resp);
      this.team_members = resp.data;
    });
  },
  methods: {
    goToForm(){
      // console.log(this.$route.params.uid);
      this.$router.push("kalendar/novi-dogadaj");
    },
    getItemText(item) {
      return `${item.ime} ${item.prezime}`;
    },
    remove(item) {
      const index = this.return_event_object.selected_team.indexOf(item);
      if (index >= 0) this.return_event_object.selected_team.splice(index, 1);
    },
    async eventCheck() {
      //add logic for dispersing edit/create

      this.return_event_object.case_id = this.caseId

      console.log(this.return_event_object);
      console.log(this.accessToken);
      await ms_calendar.addEventToCalendar(
        this.accessToken,
        this.$route.params.uid,
        this.return_event_object
      );
      // this.addNew = false;
    },
  },
};
</script>

<style>
</style>